import cx from "classnames";

import { useState } from "react";

import { ProgressBar } from "react-step-progress-bar";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";

import LockIcon from "../../../../../src/assets/images/Lockkk-icon.svg";
import LockBlackIcon from "../../../../../src/assets/images/black-lock-icon.svg";
import ArrowIcon from "../../../../../src/assets/images/arrow-icon.svg";
import DashboardImage from "../../../../../src/assets/images/dashboard-image.png";

import {
  IS_COURSE_POST_ASSESSMENT_AVAILABLE,
  LMS_COURSE_ID,
  LMS_COURSE_NAME,
} from "../../../../utils/cookiesmanager";

import Shimmer from "../ShimmerComponent";

import { CourseStatus } from "./constant";

import { useGetCourses } from "./queries";

import styles from "./styles.module.scss";
import { getTranslatedText } from "../../../../utils/getTranslatedText";
import { getTranslatedTextSelector } from "../../../../redux/slices/translatedText/getTranslatedText";
import { useSelector } from "react-redux";

const CoursesList = () => {
  const [showMessage, setShowMessage] = useState(false);
  const getLanguageId = localStorage.getItem("l_id") || 1;

  const { data: coursesData, isLoading } = useGetCourses(getLanguageId);

  const navigate = useNavigate();

  const translatedText = useSelector(getTranslatedTextSelector);

  const courses = coursesData?.data?.response || [];

  const handleCourseRedirection = (courseItem) => {
    if (showMessage) return;

    if (courseItem?.courseStatus === CourseStatus.LOCK) {
      setShowMessage(true);
      toast.info(
        "Courses Locked. Complete one screening process to unlock all courses.",
        {
          onClose: () => setShowMessage(false),
        },
      );
      return;
    }

    localStorage.setItem(LMS_COURSE_ID, courseItem?.courseId);
    localStorage.setItem(LMS_COURSE_NAME, courseItem?.courseName);
    localStorage.setItem(IS_COURSE_POST_ASSESSMENT_AVAILABLE, courseItem?.postAssessmentAvailable);

    navigate(
      `/user/module-list?courseId=${courseItem?.courseId}&courseName=${courseItem?.courseName}`,
    );
  };

  return (
    <>
      <div className={styles["list-wrapper"]}>
        <div className={styles["bg-fixed"]}></div>
        <div className={styles["header-wrapper"]}>{getTranslatedText(translatedText ,'item_courses' ,'Courses')}</div>
        <div className={styles["courses-container"]}>
        {isLoading
          ? [...Array(6)].map((_, index) => (
              <Shimmer
                key={index}
                width="100%"
                height="140px"
                borderRadius="14px"
                style={{ padding: "20px", marginBottom: "16px" }}
              />
            ))
          : courses?.map((course, index) => (
              <div
                key={index + 1}
                role="button"
                tabIndex={0}
                onClick={() => handleCourseRedirection(course)}
                className={cx(
                  styles["container-wrapper"],
                  course?.courseStatus === CourseStatus.IN_PROGRESS || course?.courseStatus === CourseStatus.COMPLETED
                    ? styles["cursor-pointer"]
                    : styles["cursor-default"],
                )}
              >
                <div className={styles["container-header"]}>
                  <div className={styles["header-left"]}>
                    <div
                      className={`${styles["image-section"]} ${styles.noMaxWidth}`}
                    >
                      <img src={course?.icon} alt={course.title} />
                    </div>

                    <div className={styles["text-section"]}>
                      <p className={styles["title-text"]}>
                        {course?.courseName}
                      </p>
                      <p className={styles["sub-title"]}>
                        {course?.courseDescription}
                      </p>

                      {course?.courseCompletePercentage !== "0%" && (
                          <div className={styles["progress-bar"]}>
                            <ProgressBar
                              percent={
                                +course?.courseCompletePercentage?.replace(
                                  "%",
                                  "",
                                )
                              }
                              filledBackground="linear-gradient(to right, #111E5B, #274CC3)"
                              width="150px"
                            />
                            <p className={styles["course-percentage"]}>
                              {course?.courseCompletePercentage}
                            </p>
                          </div>
                        )}
                    </div>
                  </div>

                  <div
                    className={`${styles["header-right"]} ${styles.noMaxWidth}`}
                  >
                    {course?.courseStatus === CourseStatus.LOCK ? <img
                      src={LockIcon}
                      alt="status"
                    /> : 
                    <img
                      src={ArrowIcon}
                      className={styles["assessment-chevron"]}
                      alt="status"
                    />}
                  </div>
                </div>

                {index === 0 &&
                  course?.courseCompletePercentage !== "100%" &&
                  course?.courseStatus !== CourseStatus.LOCK && (
                    <div className={styles["header-middle"]}>
                      <img src={LockBlackIcon} alt="Lock" />
                      <p className={styles["middle-text"]}>
                        Complete the course to unlock the Screening
                      </p>
                    </div>
                  )}
              </div>
            ))}
        </div>
        {showMessage && (
          <ToastContainer
            pauseOnHover={true}
            autoClose={2000}
            position="top-right"
            limit={1}
          />
        )}
      </div>
    </>
  );
};

export default CoursesList;
